import { render } from "./PricesCarousel.vue?vue&type=template&id=3387ff84&scoped=true"
import script from "./PricesCarousel.vue?vue&type=script&lang=js"
export * from "./PricesCarousel.vue?vue&type=script&lang=js"

import "./PricesCarousel.vue?vue&type=style&index=0&id=3387ff84&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3387ff84"]])

export default __exports__